import { useGetProductRelationShips } from './useGetProductRelationShips';
export const useHasNFSeProductActive = () => {
    const { getBillingProductNFSe } = useGetProductRelationShips();
    const nfseProduct = getBillingProductNFSe();
    return {
        hasNFSeProductActive: nfseProduct?.status === 'ACTIVATED',
        isLoading: false,
    };
};
